const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "24px",
    width: "24px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7058"
    },
    d: "M493.714,274.286h-76.617c-14.069,0-22.857-15.264-15.837-27.427 c11.52-19.955-2.589-45.716-26.403-45.716c-23.836,0-37.914,25.778-26.403,45.716c7.034,12.187-1.793,27.427-15.837,27.427H256 c-10.099,0-18.286-8.187-18.286-18.286v-52.003c-37.291,3.428-73.143-25.595-73.143-66.854c0-41.305,35.907-70.281,73.143-66.854 V18.286C237.714,8.187,245.901,0,256,0h237.714C503.813,0,512,8.187,512,18.286V256C512,266.099,503.813,274.286,493.714,274.286z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F1543F"
    },
    d: "M493.714,0H374.857v201.143c23.814,0,37.923,25.761,26.403,45.716 c-7.02,12.164,1.768,27.427,15.837,27.427h76.617c10.099,0,18.286-8.187,18.286-18.286V18.286C512,8.187,503.813,0,493.714,0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEE856"
    },
    d: "M137.143,347.429c-41.217,0-70.281-35.812-66.854-73.143H18.286C8.187,274.286,0,266.099,0,256 V18.286C0,8.187,8.187,0,18.286,0H256c10.099,0,18.286,8.187,18.286,18.286v76.617c0,14.069-15.265,22.86-27.427,15.837 c-19.961-11.522-45.716,2.595-45.716,26.403c0,23.89,25.817,37.889,45.716,26.403c12.187-7.034,27.427,1.792,27.427,15.837V256 c0,10.099-8.187,18.286-18.286,18.286h-52.003C207.404,311.434,178.548,347.429,137.143,347.429z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCE3E"
    },
    d: "M246.858,110.74c12.162,7.023,27.427-1.768,27.427-15.837V18.286C274.286,8.187,266.099,0,256,0 H137.143v347.429c41.405,0,70.261-35.994,66.854-73.143H256c10.099,0,18.286-8.187,18.286-18.286v-76.617 c0-14.045-15.241-22.869-27.427-15.837c-19.899,11.486-45.716-2.514-45.716-26.403C201.143,113.335,226.898,99.217,246.858,110.74z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4CDBC4"
    },
    d: "M256,512H18.286C8.187,512,0,503.813,0,493.714V256c0-10.099,8.187-18.286,18.286-18.286h76.617 c14.068,0,22.858,15.264,15.837,27.427c-11.522,19.961,2.595,45.716,26.403,45.716c23.886,0,37.89-25.815,26.403-45.714 c-7.034-12.186,1.792-27.429,15.837-27.429H256c10.099,0,18.286,8.187,18.286,18.286v51.99 c37.305-3.415,73.143,25.595,73.143,66.854c0,41.294-35.891,70.276-73.143,66.855v52.016C274.286,503.813,266.099,512,256,512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5AC2AD"
    },
    d: "M274.286,307.99V256c0-10.099-8.187-18.286-18.286-18.286h-76.617 c-14.045,0-22.871,15.243-15.837,27.429c11.487,19.9-2.517,45.714-26.403,45.714V512H256c10.099,0,18.286-8.187,18.286-18.286V441.7 c37.252,3.421,73.143-25.561,73.143-66.855C347.429,333.586,311.591,304.575,274.286,307.99z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#84DBFF"
    },
    d: "M493.714,512H256c-10.099,0-18.286-8.187-18.286-18.286v-76.629c0-14.069,15.265-22.86,27.427-15.837 c19.956,11.516,45.716-2.589,45.716-26.405c0-23.834-25.778-37.912-45.716-26.403c-12.186,7.033-27.427-1.79-27.427-15.835V256 c0-10.099,8.187-18.286,18.286-18.286h52.002c-3.418-37.281,25.576-73.143,66.855-73.143c41.295,0,70.273,35.888,66.855,73.143 h52.002c10.099,0,18.286,8.187,18.286,18.286v237.714C512,503.813,503.813,512,493.714,512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#54C9EB"
    },
    d: "M493.714,237.714h-52.002c3.418-37.255-25.56-73.143-66.855-73.143V512h118.857 c10.099,0,18.286-8.187,18.286-18.286V256C512,245.901,503.813,237.714,493.714,237.714z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKit);
export default __webpack_public_path__ + "static/media/kit.4eeb6c478967994972c1dffefa4d3562.svg";
export { ForwardRef as ReactComponent };